// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__32ffj","rightAdornment":"Header_rightAdornment__1fgv4"};